import React, { Component } from 'react'
import axios from 'axios'
import { API_URL } from '../constants'
import {
  map,
  pick,
  orderBy,
  uniqBy,
  isEmpty,
  get,
  toUpper,
  capitalize,
  indexOf,
  flatMap,
  reverse,
  flatten,
  size,
  has,
  lowerCase,
  intersection
} from 'lodash'
import qs from 'qs'
import {
  PageWrapper,
  Header,
  Card,
  FlexWrapper,
  Button,
  ProductViewWrapper,
  ProductView,
  PageLoader,
  SecondaryHeader
} from '../components'
import Cookies from 'js-cookie'
import { gsCalculator, priceRangeCalculator, showHeaderFromUrl, isAdmin, filterHiddenData } from '../utlis/functions'

class ViewMoreFiltered extends Component {
  state = { loader: false, data: [], favroitesData: [], selectedStores: [] }
  async componentDidMount() {
    await this.setState({ selectedStores: Cookies.getJSON('selectedStores') })
    this.setState({ loader: true })
    if (this.props.location.pathname === '/best-for-you') {
      await this.fetchBesForYou()
    } else if (this.props.location.pathname === '/best-scores') {
      await this.fetchBestScores()
    }
    await this.fetchWarningConflicts()
    await this.getFavouriteData()
    await this.setState({ loader: false })
  }
  onStoreChange = () => {
    //get stores
    const selectedStores = Cookies.getJSON('selectedStores')
    // change state to the selected stores
    this.setState({ selectedStores }, this.componentDidMount)
    // change the filters
  }

  fetchWarningConflicts = async () => {
    const warningQuery = {
      filter: { include: ['diets', 'allergies'] }
    }
    try {
      const { data } = await axios.get(`${API_URL}/users/${Cookies.get('user_id')}?${qs.stringify(warningQuery)}`)
      this.setState({ userData: data })
    } catch (error) {
      this.setState({ loader: false })
      console.log('ERROR', error)
    }
  }

  fetchBesForYou = async () => {
    const idx = [
      'gsCategoryWeightProcessing',
      'gsCategoryWeightNutrition',
      'gsCategoryWeightFoodSafety',
      'gsCategoryWeightAnimalWelfare',
      'gsCategoryWeightHumanRights',
      'gsCategoryWeightEnvironment',
      'gsCategoryWeightTransparency'
    ]
    const userDetails = orderBy(
      map(pick(Cookies.getJSON('userDetails'), idx), (item, key) => ({ key, value: item })),
      ['value'],
      ['desc']
    ).map(item => `${item.key.replace('gsCategoryWeight', '').toLowerCase()} DESC`)

    const selectedStoresFilter = !isEmpty(this.state.selectedStores)
      ? {
          and: [
            {
              totalGs: {
                gte: 70
              }
            },
            {
              or: this.state.selectedStores.map(item => ({
                storeName: item
              }))
            }
          ]
        }
      : {
          totalGs: {
            gte: 70
          }
        }
    const query = {
      filter: {
        order: userDetails,
        limit: 5000,
        where: selectedStoresFilter,
        include: ['users', 'productCost']
      }
    }

    try {
      const { data } = await axios.get(`${API_URL}/product_cost_details`, { params: { filter: query.filter } })
      const userDiets = get(this.state.userData, 'diets', []).map(item => lowerCase(item.diet))
      const userAllergies = get(this.state.userData, 'allergies', []).map(item => lowerCase(item.allergy))
      const newData = data.filter(item => {
        const allergyConflicts = get(item, 'product.allergyConflicts', '')
          .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
          .toLowerCase()
          .split(',')
          .map(item => item.trim())
        const dietConflicts = get(item, 'product.dietConflicts', '')
          .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
          .toLowerCase()
          .split(',')
          .map(item => item.trim())
        return isEmpty(intersection(userAllergies, allergyConflicts)) && isEmpty(intersection(userDiets, dietConflicts))
      })
      this.setState({ data: uniqBy(newData, 'productType'), loader: false })
    } catch (error) {
      this.setState({ loader: false })
      console.log(error)
    }
  }

  fetchBestScores = async () => {
    const selectedStoresFilter = !isEmpty(this.state.selectedStores)
      ? {
          and: [
            {
              totalGs: {
                gte: 80
              }
            },
            {
              or: this.state.selectedStores.map(item => ({
                storeName: item
              }))
            }
          ]
        }
      : {
          totalGs: {
            gte: 80
          }
        }
    const query = {
      filter: {
        where: selectedStoresFilter,
        order: ['totalGs DESC'],
        limit: 2000,
        include: ['productCost', 'users']
      }
    }

    try {
      const { data } = await axios.get(`${API_URL}/product_cost_details`, { params: { filter: query.filter } })
      this.setState({ data: uniqBy(data, 'productType'), loader: false })
    } catch (error) {
      this.setState({ loader: false })
      console.log(error)
    }
  }

  getFavouriteData = async () => {
    try {
      const { data } = await axios.get(
        `${API_URL}/users/${Cookies.get('user_id')}/productTables?filter=%7B%22fields%22%3A%22productCode%22%7D`
      )
      this.setState({ favouriteData: data })
    } catch (error) {
      console.log('ERROR', error)
    }
  }
  changeFavouriteData = async id => {
    const query = {
      filter: {
        where: { userId: Cookies.get('user_id'), productCode: id }
      }
    }
    const { data } = await axios.get(`${API_URL}/UserProducts?${qs.stringify(query)}`)
    if (data.length === 0) {
      await axios.post(`${API_URL}/UserProducts`, {
        productCode: id,
        userId: Cookies.get('user_id')
      })
      await this.getFavouriteData()
    } else {
      await axios.delete(`${API_URL}/UserProducts/${data[0].id}`)
      await this.getFavouriteData()
    }
  }
  render() {
    const { location } = this.props
    const { favouriteData, data, loader, userData } = this.state
    const favouriteDataz = flatMap(favouriteData, 'productCode')
    const userDiets = get(userData, 'diets', []).map(item => lowerCase(item.diet))
    const userAllergies = get(userData, 'allergies', []).map(item => lowerCase(item.allergy))
    return (
      <React.Fragment>
        <Header
          title={showHeaderFromUrl(get(location, 'pathname', ''))}
          icon="arrowBack"
          onClickBack={() => this.props.history.goBack()}
          color="#fff"
        />
        <SecondaryHeader clicked={this.onStoreChange} padding="70px 16px 0" />
        <PageWrapper viewPadding="22.4% 4.3% 6.4%" height="auto" modifyPadding="14px 16px 24px">
          {loader ? (
            <PageLoader />
          ) : isEmpty(filterHiddenData(data)) ? (
            <Card boxShadow="0 3px 6px 0 rgba(0, 0, 0, 0.16)" borderRadius="5px" bgColor="#fff">
              <FlexWrapper alignItems="center">
                <h3>No Results available</h3>
                <Button
                  type="submit"
                  label="View Products"
                  volume="filled"
                  margin="14px 10px 0"
                  size="small"
                  onClick={() => this.props.history.push('/products')}
                />
              </FlexWrapper>
            </Card>
          ) : (
            <ProductViewWrapper direction="row" flexWrap="wrap" justifyContent="space-between">
              {filterHiddenData(data).map(item => {
                const priceRange = get(item, 'productCost', []).map(range =>
                  range.productPriceSale ? range.productPriceSale : range.productPriceOriginal
                )

                const allergyConflicts = get(item, 'allergyConflicts', '')
                  .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                  .toLowerCase()
                  .split(',')
                  .map(item => item.trim())
                const dietConflicts = get(item, 'dietConflicts', '')
                  .replace(/(\r\n\t|\n|\r\t|\r)/gm, '')
                  .toLowerCase()
                  .split(',')
                  .map(item => item.trim())
                return (
                  <ProductView
                    conflict={
                      !isEmpty(intersection(userAllergies, allergyConflicts)) ||
                      !isEmpty(intersection(userDiets, dietConflicts))
                    }
                    cardMargin="0 0 10px 0"
                    cardWidth="166px"
                    cardHeight="236px"
                    favValue={get(item, 'users', '') ? get(item, 'users.length', '') : 0}
                    key={item.productCode}
                    imageUrl={get(item, 'productImage', '')}
                    quantity={
                      size(get(item, 'productQuantity', '')) < 15 ? toUpper(get(item, 'productQuantity', '')) : ''
                    }
                    productName={capitalize(get(item, 'productName', ''))}
                    priceRange={priceRangeCalculator(priceRange)}
                    progressValue={Math.round(item.totalGs, 0)}
                    isFavorite
                    isHidden={isAdmin() && item.isHidden ? true : false}
                    favoriteActive={indexOf(favouriteDataz, get(item, 'productCode', '')) === -1 ? false : true}
                    onFavorite={() => this.changeFavouriteData(get(item, 'productCode', ''))}
                    onClick={() =>
                      this.props.history.push({
                        pathname: `/products/${get(item, 'productCode', '')}/green-score`
                      })
                    }
                  />
                )
              })}
            </ProductViewWrapper>
          )}
        </PageWrapper>
      </React.Fragment>
    )
  }
}

export default ViewMoreFiltered



// WEBPACK FOOTER //
// ./src/pages/ViewMoreFiltered.js